"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCustomerEmail = void 0;
const getCustomerState_1 = require("../helper/getCustomerState");
const saltHashEmail_1 = require("../helper/saltHashEmail");
const pushToDataLayer_1 = require("./pushToDataLayer");
function trackCustomerEmail(customerEmail) {
    const customerData = {
        email: customerEmail.toLowerCase(),
        emailsha256salt: (0, saltHashEmail_1.saltHashEmail)(customerEmail),
        ...(0, getCustomerState_1.getCustomerState)(),
    };
    if (!window.dataLayer) {
        window.dataLayer = [];
    }
    const dataLayer = window?.dataLayer;
    const customerIndex = window.dataLayer.findIndex(item => item?.Customer);
    if (customerIndex >= 0) {
        dataLayer[customerIndex] = { Customer: customerData };
        window.dataLayer = dataLayer;
    }
    else {
        (0, pushToDataLayer_1.pushToDataLayer)({ Customer: customerData });
    }
}
exports.trackCustomerEmail = trackCustomerEmail;
//# sourceMappingURL=trackCustomerEmail.js.map